export enum UserAction {
    POST_LOAD = "post_load",
    POST_LORRY = "post_lorry",
    LOAD_BID = "load_bid",
    LORRY_BID = "lorry_bid",
    SEND_C2C_REQUEST = "send_c2c_request",
    SEND_CONNECTION_REQUEST = "send_connection_request",
    SIM_TRACKING_REQUEST = "simTracking"
}

export enum UserActionRequiredResponse {
    VERIFY_AADHAAR = "aadhaar_verification",
    VERIFY_PAN = "pan_verification",
    VERIFY_GST = "gst_verification",
    BUY_MEMBERSHIP = "buy_membership",
    TOP_UP_MEMBERSHIP = "topup_membership",
    UPGRADE_MEMBERSHIP = "upgrade_membership",
    DAILY_MEMBERSHIP_LIMIT_EXHAUSTED = "daily_membership_limit_exhausted",
    EDIT_COMPANY_NAME = "edit_company_name",
    MEMBERSHIP_EXPIRED = "membership_expired",
    CLEAR_CASHBACK_COINS = "clear_cashback_coins"
}
